var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDnnLogoPrimary = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 81 31.95"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#472a2b",
  d: "M45 19.5h-2.37v-4.76H45a2.38 2.38 0 0 1 0 4.76m0-8.85h-6.58v12.94H45a6.47 6.47 0 0 0 0-12.94M66.1 17.06a6.48 6.48 0 0 0-6.48-6.41h-6.47v12.94h4.21v-8.73h2.26a2.26 2.26 0 0 1 2.27 2.26v6.47h4.21zM81 17.06a6.47 6.47 0 0 0-6.47-6.41h-6.48v12.94h4.21v-8.73h2.27a2.26 2.26 0 0 1 2.26 2.26v6.47H81z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ef3e42",
  d: "M21.3 10.65V.91A16 16 0 0 0 16 0H0v21.3h10.65V10.65Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#472a2b",
  d: "M21.3.91v9.74H31A16 16 0 0 0 21.3.91M0 32h10.65V21.3H0Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#00a4e4",
  d: "M31 10.65h-9.7V16a5.33 5.33 0 0 1-5.3 5.3h-5.35V32H16a16 16 0 0 0 15-21.35"
})));
export default SvgDnnLogoPrimary;